/// <reference path="./src/types/mui.d.ts" />
export * from '@mui/material';
export { default as createSvgIcon } from '@mui/material/utils/createSvgIcon';

export * from './src/theme';
export * as colors from './src/colors';
